module.exports = __webpack_public_path__ + "img/22.4e179303.jpg";